import React from 'react'

interface PlateCoverImageProps {
  imageUrl?: string | null
  isAddPlusImg?: boolean
  alt?: string
  className?: string
  width?: number
  height?: number
}

const PlateCoverImage: React.FC<PlateCoverImageProps> = ({
  imageUrl,
  isAddPlusImg = false,
  alt = '커버',
  className = '',
  width,
  height,
}) => {
  const backgroundImageWidth = 169.34
  const backgroundImageHeight = 108.09

  return (
    <div
      className={`${className} flex [&_img]:select-none [&_img]:[-webkit-touch-callout:none]`}
      style={{
        ...(width !== undefined && { width: `${width}px` }),
        ...(height !== undefined && { height: `${height}px` }),
      }}
    >
      <div
        className="m-auto"
        style={{
          position: 'relative',
          width: '100%',
          paddingBottom: `${
            (backgroundImageHeight / backgroundImageWidth) * 100
          }%`,
        }}
      >
        {/* Background */}
        <img
          src="/images/default-category-cover-bg.png?v=5"
          alt="배경"
          draggable={false}
          className="absolute top-0 left-0 w-full h-full object-contain"
        />

        {imageUrl && (
          <div
            style={{
              position: 'absolute',
              top: `${(5 / backgroundImageHeight) * 100}%`,
              left: `${(4 / backgroundImageWidth) * 100}%`,
              width: `${(97 / backgroundImageWidth) * 100}%`,
              height: `${(97 / backgroundImageHeight) * 100}%`,
              borderRadius: '4px',
              overflow: 'hidden',
            }}
          >
            <img
              src={imageUrl}
              alt={alt}
              draggable={false}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {isAddPlusImg && (
          <div
            style={{
              position: 'absolute',
              bottom: `${(3.77 / backgroundImageHeight) * 100}%`,
              right: `${(13.06 / backgroundImageWidth) * 100}%`,
              width: `${(22.69 / backgroundImageWidth) * 100}%`,
              height: `${(22.66 / backgroundImageHeight) * 100}%`,
              overflow: 'hidden',
            }}
          >
            <img
              src="/images/plate-plus-icon.png"
              alt="추가"
              draggable={false}
              className="w-full h-full object-contain"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PlateCoverImage
